import React from 'react';

const Sushime = () => {
    const styles = {
        container: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 20px',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            // fontFamily: 'Arial, sans-serif'
        },
        logoContainer: {
            marginBottom: '30px'
        },
        logo: {
            width: '150px',
            height: 'auto',
            borderRadius: '10px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
        },
        title: {
            fontSize: '2.5rem',
            color: '#2c3e50',
            textAlign: 'center',
            marginBottom: '20px',
            fontWeight: 'bold'
        },
        subtitle: {
            fontSize: '1.8rem',
            color: '#e74c3c',
            textAlign: 'center',
            marginBottom: '30px'
        },
        description: {
            fontSize: '1.2rem',
            color: '#34495e',
            textAlign: 'center',
            maxWidth: '600px',
            marginBottom: '40px',
            lineHeight: '1.6'
        },
        buttonContainer: {
            display: 'flex',
            gap: '20px',
            flexWrap: 'wrap',
            justifyContent: 'center'
        },
        baseButton: {
            padding: '15px 30px',
            border: 'none',
            borderRadius: '25px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            textDecoration: 'none',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
        },
        homeButton: {
            backgroundColor: '#3498db',
            color: 'white'
        },
        orderButton: {
            backgroundColor: '#27ae60',
            color: 'white'
        },
        discountButton: {
            backgroundColor: '#e74c3c',
            color: 'white'
        }
    };

    return (
        <div style={styles.container}>
            {/* <div style={styles.logoContainer}>
                <img src="/logo.png" alt="Sushi Yu Logo" style={styles.logo} />
            </div> */}
            
            <h1 style={styles.title}>Sushi Me Customers:</h1>
            
            <h2 style={styles.subtitle}>We are now Sushi Yu!</h2>
            
            <p style={styles.description}>
               Same location, same menu — now 20% off all sushi &amp; rolls!
            </p>
            
            <div style={styles.buttonContainer}>
                <a href="/" style={{...styles.baseButton, ...styles.homeButton}}>
                    Visit Home Page
                </a>
                
                <a href="/alhambra/order" style={{...styles.baseButton, ...styles.orderButton}}>
                    Order Now
                </a>
            </div>
        </div>
    );
};

export default Sushime;
